// modal to open urls

import { useEffect, useState } from "react";

import { getFileInfoFromFilePath, getFileType, checkIsFile } from '@/utils/File';

import PDFViewer from '@/components/PDFViewer';
import ImageViewer from '@/components/ImageViewer';
import IframeViewer from '@/components/IframeViewer';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

export default function UrlViewerModal({t, open, setOpen, url, fullScreen, file, type, mime, name, title, disclaimer, download, external, embedded}){	

    // force pdf to be embedded
    //embedded = true;

    const handleClose = () => {
        setOpen(false);
    }

    const [ fileType, setFileType ] = useState(null);
    //const [ mimeType, setMimeType ] = useState(null);
    const [ fileName, setFileName ] = useState('');

    useEffect(() => {

        // check if it is file
        var isFile = false;
        if(file !== null){
            isFile = file;
        }
        else{
            // if not specified, check if the url is a file
            isFile = checkIsFile(url);
        }

        if(url && url?.length > 0 && isFile){

            const { type: typeInfo, name: nameInfo } = getFileInfoFromFilePath(t,url);     

            if(type && type?.length > 0){
                setFileType(type);
            }
            else{
                // if no file type but mime, get from mime
                if(mime && mime?.length > 0){
                    const getType = getFileType(mime); 
                    setFileType(getType);
                }
                else{
                    // if not, get from url
                    setFileType(typeInfo);
                }
            }         

            /*
            if(mime && mime?.length > 0){
                setMimeType(mime);
            }
            else{
                setMimeType(mimeInfo);
            }     
            */       

            if(name && name?.length > 0){
                setFileName(name);
            }
            else{
                setFileName(nameInfo);
            }
        }
        else{
            setFileType(null);
            //setMimeType(null);
            setFileName('');
        }

    },[url]);

    const downloadFile = async () => {

        // force download
        let finalUrl = url;
        try{
            const response = await fetch(url);

            if(response.ok){            
                const blob = await response.blob(); 
                finalUrl = window.URL.createObjectURL(blob);
            }
        }
        catch(err){
            if(err){
                console.log(err)
            }
        }        

        const link = document.createElement("a");
        link.href = finalUrl;
        link.download = fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);

        // free temporary url
        window.URL.revokeObjectURL(finalUrl);
    }

    return (        
        open &&
        (
            fileType ? 
                fileType === 'pdf' ?
                    <PDFViewer
                        open={open}
                        t={t}
                        url={url}                        
                        title={title && title?.length > 0 ? title : embedded && name && name?.length > 0 ? name : ''}                        
                        disclaimer={disclaimer}
                        download={download}
                        downloadFile={downloadFile}
                        embedded={embedded}
                        external={external}
                        fullScreen={fullScreen}
                        handleClose={handleClose}
                    />
                :
                    fileType === 'image' ?
                        <ImageViewer
                            open={open}                            
                            url={url}
                            title={title}                            
                            disclaimer={disclaimer}
                            download={download}
                            downloadFile={downloadFile}
                            external={external}
                            fullScreen={fullScreen}
                            handleClose={handleClose}
                        />
                    :
                        <iframe
                            src={url}                    
                            style={{width:'0', height: '0'}}
                        ></iframe>
            :
                <IframeViewer
                    open={open}
                    url={url}
                    title={title}
                    disclaimer={disclaimer}
                    download={download}
                    downloadFile={downloadFile}
                    fullScreen={fullScreen}
                    handleClose={handleClose}
                />  
        )
    );
}